var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTasksBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.529,
    height: 13.466
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17965",
    d: "M.15.316h13v13h-13z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31525",
    d: "M13.316 2.243L5.805 9.761 3.014 6.97l.928-.928 1.863 1.863 6.583-6.583zm-1.455 3.318a5.263 5.263 0 11-5.128-4.094 5.214 5.214 0 012.818.823l.948-.948A6.517 6.517 0 006.733.15a6.6 6.6 0 106.188 4.351z",
    fill: "#001847",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}

export default SvgTasksBlack;